import { Component, computed, input, makeStateKey, output, signal } from '@angular/core';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { ContentLinksComponent } from '@app/components/content-links/content-links.component';
import { GoogleRatingComponent } from '@app/components/google-rating/google-rating.component';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { MediaComponent } from '@app/components/media/media.component';
import { TextComponent } from '@app/components/text/text.component';
import { NodeLocation } from '@app/models/entity.model';
import { Media } from '@app/models/media.model';
import { ParagraphPgPnav } from '@app/models/paragraph.model';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { MobiUiExpanderComponent } from '@mobi/rwc-ui-components-ng-jslib';

@Component({
  selector: 'mobi-ga-header',
  imports: [
    BreadcrumbComponent,
    ComponentSharedModule,
    MobiUiIconComponent,
    MediaComponent,
    GoogleRatingComponent,
    TextComponent,
    MobiUiExpanderComponent,
    ContentLinksComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  readonly title = input.required<string>();
  readonly secondaryTitle = input<string | undefined>('');
  readonly lead = input<string | undefined>('');
  readonly moreText = input<string | undefined>('');
  readonly image = input<Media | undefined>();
  readonly locations = input<NodeLocation[] | undefined>([]);
  readonly openingHours = input('');
  readonly mainAgency = input<NodeLocation | undefined>(undefined);
  readonly contentLinks = input<ParagraphPgPnav[]>([]);

  formattedTitle = computed(() => this.#nonBrHypens(this.title()));
  readonly goTo = output();

  #nonBrHypens(title: string) {
    return title.replace(/-/g, '&#x2011;');
  }
}
